import { useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CustomLoader from "./loader";
import axios from "axios";

const RedirectSite = () => {
  //   const { phone, businessid, text } = useParams();
  let phone;
  let businessid;
  let text;
  let customerid;
  let department;
  let scancode;

  const location = useLocation();
  const navigate = useNavigate();

  function isMobile() {
    if (navigator.userAgentData) {
      return navigator.userAgentData.mobile;
    }
    return false;
  }

  useEffect(() => {
    redirectTo();
  }, [navigate]);

  const redirectTo = async () => {
    const queryParams = new URLSearchParams(location.search);
    phone = queryParams.get("phone");
    businessid = queryParams.get("businessid");
    text = queryParams.get("text");
    department = queryParams.get("department");
    customerid = queryParams.get("customerid");
    scancode = queryParams.get("scancode");
    text = encodeURIComponent(text);
    let paramString = `businessid=${businessid}&customerid=${customerid}&department=${department}&scancode=${scancode}`;
    // console.log(department, phone, text, customerid, scancode);
    try {
      const url = "https://us-central1-connexions-85d01.cloudfunctions.net/mobiguest_services";
      const payload = { reqtype: "drvtse", clientid: "27sln81ar19wr2v8u", reqinfo: paramString };
      const res = await axios.post(url, payload);
      paramString = "data=" + res.data;
    } catch (e) {}
    const whatsappURLMobile = `whatsapp://send?phone=${phone}&text=${text}`;
    const fallbackURL = `https://ai.mobiguest.com/?${paramString}`;
    if (isMobile()) {
      window.location.href = whatsappURLMobile;
      const fallbackTimeout = setTimeout(() => {
        window.location.href = fallbackURL;
      }, 2000);
      window.addEventListener("blur", () => clearTimeout(fallbackTimeout));
    } else {
      window.location.href = fallbackURL;
    }
  };

  return (
    <div style={{ width: "100%", alignItems: "center" }}>
      <CustomLoader />
    </div>
  );
};

export default RedirectSite;
